import { HttpErrorResponse } from "@angular/common/http";

import { EmployeeDto, EmployeeModel } from "@core/models/employee.model";
import { createAction, props } from "@ngrx/store";

export const EMPLOYEES_ACTION_FAILURE = createAction(
  "[Employees] Employees Action Failure",
  props<{ error: HttpErrorResponse }>()
);

export const SET_EMPLOYEES_LOADING = createAction(
  "[Employees] Set Employees Loading",
  props<{ loading: boolean }>()
);

export const SET_EMPLOYEES_LIST = createAction(
  "[Employees] Set Employee List",
  props<{ employeesList: Array<EmployeeModel> }>()
);

export const LOAD_EMPLOYEES = createAction("[Employees] Load Employees");

export const SAVE_EMPLOYEE = createAction(
  "[Employee] Save Employee",
  props<{ data: Omit<EmployeeDto, "version"> }>()
);

export const UPDATE_EMPLOYEE = createAction(
  "[Employee] Update Employee",
  props<EmployeeDto & { id: string }>()
);

export const ACTIVATE_EMPLOYEE = createAction(
  "[Employee] Activate Employee",
  props<{ id: string }>()
);

export const DEACTIVATE_EMPLOYEE = createAction(
  "[Employee] Deactivate Employee",
  props<{ id: string }>()
);

export const RESEND_CONFIRMATION = createAction(
  "[Employee] Resend Confirmation",
  props<{ id: string }>()
);
